import {
  CLEAR_FETCHED_PUPILS,
  SEARCH_PUPILS,
  SEARCH_PUPILS_FOR_EVENT,
  SEARCH_PUPILS_FAILURE,
  SEARCH_PUPILS_SUCCESS,
  GET_PUPILS_DELIVERY_LOCATION,
  GET_PUPILS_DELIVERY_LOCATION_SUCCESS,
} from '../constants/ActionTypes';

const DEFAULT_STATE = {
  fetchedPupils: [],
  loading: false,
  locations: {},
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CLEAR_FETCHED_PUPILS:
      return {
        ...state,
        fetchedPupils: [],
        fetchedPupilPageCount: 0,
      };
    case SEARCH_PUPILS:
    case SEARCH_PUPILS_FOR_EVENT:
      return {
        ...state,
        loading: true,
        fetchedPupilPageCount: 0,
      };
    case SEARCH_PUPILS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_PUPILS_SUCCESS:
      return {
        ...state,
        fetchedPupils: action.payload.fetchedPupils,
        fetchedPupilPageCount: action.payload.pageCount,
        loading: false,
      };
    case GET_PUPILS_DELIVERY_LOCATION: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_PUPILS_DELIVERY_LOCATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        locations: action.payload,
      };
    }
    default:
      return state;
  }
};
